import { createStackNavigator } from "@react-navigation/stack";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export const WorkspaceSignalStack =
  createStackNavigator<WorkspaceSignalStackParamList>();

export type WorkspaceSignalStackParamList = {
  WorkspaceSignalsMain: object;
  WorkspaceSignalsArchived: {
    workspaceId: string;
  };
  WorkspaceSignalDetail: {
    workspaceId: string;
    signalWorkspaceId: string;
  };
};

export type WorkspaceNavigationProp<
  T extends keyof WorkspaceSignalStackParamList,
> = CompositeNavigationProp<
  NativeStackNavigationProp<WorkspaceSignalStackParamList, T>,
  UserLoggedInNavigatorNavigationProp<"OrgHome">
>;

export type WorkspaceSignalStackScreenProps<
  T extends keyof WorkspaceSignalStackParamList,
> = {
  route: RouteProp<WorkspaceSignalStackParamList, T>;
  navigation: WorkspaceNavigationProp<T>;
};
